(function () {
    'use strict';

    function deleteRequestForProposalResponseModalController($scope, $uibModalInstance, notifyService, requestForProposalResponseDataService,
        rfpResponseId, entityName) {

        $scope.entityName = entityName;
        $scope.ok = function () {
            requestForProposalResponseDataService.deleteRequestForProposalResponse(rfpResponseId).then(
                function() {
                    notifyService.notify(entityName ?
                        'This RFP response for ' + entityName + ' has been deleted' :
                        'The RFP response has been deleted');
                });
            $uibModalInstance.close(true);
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        }
    }

    deleteRequestForProposalResponseModalController.$inject = ['$scope', '$uibModalInstance', 'notifyService',
        'requestForProposalResponseDataService', 'rfpResponseId', 'entityName'];

    angular.module('ecap.requestForProposal').controller('deleteRequestForProposalResponseModalController', deleteRequestForProposalResponseModalController);
})();
